(function (Drupal, $) {

  $(function () {
    var v = document.querySelectorAll('.video-player');

    function createvideoId() {
      var i;
      for (i = 0; i < v.length; i++) {
        v[i].setAttribute('id', 'video-play-'+i)
      }
    }

    function createVideoThumbnail() {
      var div, n;

      for (n = 0; n < v.length; n++) {
        div = document.createElement('div');
        div.setAttribute('data-id', v[n].dataset.id);
        div.setAttribute('data-vtype', v[n].dataset.vtype);
        div.setAttribute('class', 'thumbnail-wrapper');
        div.innerHTML = labnolThumb(v[n].dataset.id, n);
        div.onclick = labnolIframe;
        v[n].appendChild(div);
      }
    }

    function labnolThumb(id, counter) {
      var url, thumb, play;
      url = v[counter].parentNode.nextElementSibling.innerText;
      thumb = '<img src="'+url+'">';
      play = '<button class="play"></button>';
      return thumb + play;
    }

    function labnolIframe() {
      var div = document.createElement('div');
      div.setAttribute('class', 'embed-wrapper');
      div.setAttribute('style', 'padding: 56.25% 0 0 0; position: relative;');

      var iframe = document.createElement('iframe');

      if (this.dataset.vtype == 'youtube') {
        var embed = "https://www.youtube.com/embed/ID?autoplay=1&rel=0";
      }

      if (this.dataset.vtype == 'vimeo') {
        var embed = 'https://player.vimeo.com/video/ID?autoplay=1';
      }

      iframe.setAttribute('src', embed.replace('ID', this.dataset.id));
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allowfullscreen', '1');
      iframe.setAttribute('style', 'position: absolute; top: 0; left: 0; width: 100%; height: 100%;');

      div.appendChild(iframe);
      this.parentNode.replaceChild(div, this);
    }

    createvideoId();
    createVideoThumbnail();

  });


})(Drupal, jQuery);
